import { jsx as o, Fragment as X, jsxs as K } from "react/jsx-runtime";
import { useRef as s, useState as P, useEffect as B, useCallback as d } from "react";
import Y from "./CarouselUtils.class.js";
import { CarouselSlide as Z } from "../CarouselSlide/CarouselSlide.js";
import { chunkArray as ee, classes as _ } from "../../utils/helpers.js";
import { c as a } from "../../Carousel.module-DOrBKQEQ.mjs";
import { C as re } from "../../chevron-left-DmvQntvu.mjs";
import { C as te } from "../../chevron-right-CaAz6ISN.mjs";
const b = window.matchMedia("(width <= 600px)"), z = window.matchMedia("(width <= 800px"), E = window.matchMedia("(width <= 1024px"), L = window.matchMedia("(width <= 1280px");
function de({
  id: g,
  slides: x,
  options: I = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 48,
    controlButtonsOffset: 12,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: "",
    autoplay: !1,
    autoplayDelay: 3500,
    showPagination: !1,
    gutterSize: 25,
    slideAspectRatio: "4/2",
    slideGap: 1.5,
    cellsPerSlide: 1,
    cellAspectRatio: "4/2",
    cellsPosition: "center",
    wrapAround: !0
  }
}) {
  console.log(`Carousel component with id: ${g} initialized`);
  const p = s(`carousel-${g}`), R = s(null), i = s(null), $ = s(null), m = s(x), T = s(null), S = s(null), r = s(null), e = s(I), l = s(I), N = s("-50%"), [M, G] = P([]), [k, H] = P([]), [D, U] = P(0);
  B(() => {
    const t = () => {
      b.matches ? e.current = {
        ...l.current,
        showControls: !1,
        showPagination: !1,
        cellsPerSlide: 1,
        cellsPosition: l.current.wrapAround ? "center" : "flex-start",
        gutterSize: 10
      } : z.matches ? l.current.cellsPerSlide !== 1 ? e.current = {
        ...l.current,
        cellsPerSlide: 2,
        showControls: !1,
        gutterSize: 10
      } : e.current = {
        ...l.current,
        showControls: !1,
        gutterSize: 10
      } : E.matches ? l.current.cellsPerSlide !== 1 && l.current.cellsPerSlide !== 2 ? e.current = {
        ...l.current,
        cellsPerSlide: 3,
        showControls: !1,
        gutterSize: 10
      } : e.current = {
        ...l.current,
        showControls: !1,
        gutterSize: 10
      } : L.matches ? l.current.showPagination ? e.current = {
        ...l.current,
        showControls: !1
      } : e.current = {
        ...l.current
      } : e.current = {
        ...l.current
      };
    };
    t();
    const n = () => {
      U((u) => u + 1), t();
    };
    return b.addEventListener("change", n), z.addEventListener("change", n), E.addEventListener("change", n), L.addEventListener("change", n), () => {
      b.removeEventListener("change", n), z.removeEventListener("change", n), E.removeEventListener("change", n), L.removeEventListener("change", n);
    };
  }, []);
  const O = d((t, n) => {
    const u = ee(n, t);
    H([...u]);
    let h = [];
    for (let c = 0; c <= u.length - 1; c++) {
      h[c] = {}, h[c].ariaLabel = `${c + 1} of ${u.length}`, h[c].layout = u[c][0].layout, h[c].cells = [];
      for (let w = 0; w <= u[c].length - 1; w++)
        h[c].cells[w] = {
          props: u[c][w].props
        };
    }
    const C = [...h], A = [...h], J = C.slice(-1), Q = C.slice(0);
    return A.push(Q[0]), A.unshift(J[0]), e.current.wrapAround && t.length > n ? A : C;
  }, []), f = d(() => {
    e.current.autoplay && r.current.clearTimer();
  }, []), F = d((t) => {
    f();
    const n = t.key;
    n === "ArrowLeft" ? (t.preventDefault(), r.current.determineScrollAction(-1)) : n === "ArrowRight" && (t.preventDefault(), r.current.determineScrollAction(1));
  }, [f]), W = d(() => {
    f(), i.current.addEventListener("scrollend", () => {
      r.current.handleScrollEnd();
    }, { once: !0 });
  }, [f]), v = d(() => {
    f(), i.current.addEventListener("scrollend", () => {
      r.current.handleScrollEnd(), i.current.addEventListener("scroll", v, { once: !0 });
    }, { once: !0 });
  }, [f]), q = () => {
    r.current && e.current.autoplay && r.current.clearTimer();
  }, y = d(() => {
    //! make sure class is only instantiated once because of reacts
    //! "strict" mode double do hocus pocus
    var t, n;
    r.current !== null && D > 0 && ((n = (t = r.current).clearTimer) == null || n.call(t), r.current = null), r.current = new Y({
      carouselEl: R.current,
      scrollerEl: i.current,
      paginationEl: $.current,
      slides: m.current,
      navBtnEls: {
        next: T.current,
        previous: S.current
      },
      id: p.current,
      options: {
        autoplay: e.current.autoplay,
        wrapAround: e.current.wrapAround && m.current.length > e.current.cellsPerSlide,
        showPagination: e.current.showPagination,
        delay: e.current.autoplayDelay,
        slideGutterSize: e.current.gutterSize,
        slideAspectRatio: e.current.slideAspectRatio,
        showControls: e.current.showControls && m.current.length > e.current.cellsPerSlide,
        cellsPerSlide: e.current.cellsPerSlide
      }
    });
  }, [D]), V = d(() => {
    i.current.addEventListener("scroll", v, { once: !0 });
  }, [v]), j = d(() => {
    if (G(O(m.current, e.current.cellsPerSlide)), m.current.length > e.current.cellsPerSlide) {
      let t = setInterval(() => {
        i.current !== null && (S.current !== null && e.current.showControls || !e.current.showControls) && (clearInterval(t), V(), y());
      }, 100);
    } else {
      let t = setInterval(() => {
        i.current !== null && (clearInterval(t), y());
      }, 100);
    }
  }, [O, V, y]);
  return B(() => {
    if (e.current !== null) {
      if (e.current.showControls) {
        let t = 0;
        e.current.showPagination && (t = t + 25), e.current.showScrollbar && (t = t + 6), N.current = `calc(-50% - ${t}px)`;
      }
      j();
    }
    return () => {
      q();
    };
  }, [j, e]), /* @__PURE__ */ o(X, { children: e.current !== null && /* @__PURE__ */ K(
    "div",
    {
      className: a.carousel,
      id: p.current,
      ref: R,
      tabIndex: -1,
      role: "region",
      "aria-roledescription": "carousel",
      "aria-label": e.current.title,
      onKeyDown: F,
      style: {
        "--_carousel-gutters": e.current.wrapAround ? `${e.current.gutterSize <= 25 ? e.current.gutterSize : 25}%` : `0 ${e.current.gutterSize <= 25 ? e.current.gutterSize : 25}%`,
        "--_slide-aspect-ratio": e.current.slideAspectRatio,
        "--_cell-aspect-ratio": e.current.cellAspectRatio,
        "--_slide-cell-size": `${100 / e.current.cellsPerSlide}%`,
        "--_cells-position": e.current.cellsPosition,
        "--_control-btns-offset-x": `${e.current.controlButtonsOffset}rem`,
        "--_slide-gap": `${e.current.slideGap}rem`,
        "--_controls-transform": N.current
      },
      children: [
        /* @__PURE__ */ o(
          "ol",
          {
            className: a.carousel__scroller,
            ref: i,
            role: "group",
            "aria-label": "Items Scroller",
            "aria-live": "Polite",
            tabIndex: 0,
            onMouseEnter: () => {
              e.current.autoplay && r.current !== null && r.current.clearTimer();
            },
            onMouseLeave: () => {
              e.current.autoplay && r.current !== null && r.current.startTimer();
            },
            onTouchStart: W,
            "data-scrollbar": e.current.showScrollbar,
            children: M.length > 0 && M.map((t, n) => /* @__PURE__ */ o(
              Z,
              {
                slide: t,
                index: n,
                currentIndex: e.current.wrapAround ? 1 : 0,
                variableHeight: e.current.variableHeight
              },
              `carousel${g}-slide${n}`
            ))
          }
        ),
        e.current.showControls && x.length > e.current.cellsPerSlide && /* @__PURE__ */ K("div", { className: a["carousel-controls"], children: [
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              ref: S,
              title: "Previous Item",
              className: _([a["carousel-controls__btn"], a["carousel-controls__previous"], "carousel-controls__previous"]),
              "aria-controls": p.current,
              "aria-label": "Previous Item",
              onClick: () => {
                r.current.determineScrollAction(-1);
              },
              onMouseEnter: () => {
                e.current.autoplay && r.current !== null && r.current.clearTimer();
              },
              onMouseLeave: () => {
                e.current.autoplay && r.current !== null && r.current.startTimer();
              },
              children: /* @__PURE__ */ o("i", { "aria-hidden": "true", children: /* @__PURE__ */ o(re, { width: e.current.controlArrowSize, height: e.current.controlArrowSize }) })
            }
          ),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              ref: T,
              title: "Next Item",
              className: _([a["carousel-controls__btn"], a["carousel-controls__next"], "carousel-controls__next"]),
              "aria-controls": p.current,
              "aria-label": "Next Item",
              onClick: () => {
                r.current.determineScrollAction(1);
              },
              onMouseEnter: () => {
                e.current.autoplay && r.current !== null && r.current.clearTimer();
              },
              onMouseLeave: () => {
                e.current.autoplay && r.current !== null && r.current.startTimer();
              },
              children: /* @__PURE__ */ o("i", { "aria-hidden": "true", children: /* @__PURE__ */ o(te, { width: e.current.controlArrowSize, height: e.current.controlArrowSize }) })
            }
          )
        ] }),
        e.current.showPagination && k.length > 1 && /* @__PURE__ */ o("div", { className: [a["carousel-nav"], "carousel-nav"].join(" "), children: /* @__PURE__ */ o("ol", { className: a["carousel-nav__list"], ref: $, children: k.map((t, n) => /* @__PURE__ */ o(
          "li",
          {
            className: _([a["carousel-nav__item"], "carousel-nav__item"]),
            "data-current": n === 0 ? "true" : "false",
            onClick: () => {
              r.current.navigateToIndex(n);
            },
            title: `Navigate to slide ${n + 1}`
          },
          `carousel${p}-nav-${n}`
        )) }) })
      ]
    }
  ) });
}
export {
  de as Carousel,
  de as default
};
